import { useState, useEffect, useMemo } from 'react';

function useImageLoadingState(props) {
  const {
    src,
    onStateChange
  } = props;
  const [state, setState] = useState('initial');
  useEffect(() => {
    setState('loading');
    onStateChange && onStateChange('loading');
  }, [src, onStateChange]);
  const imgProps = useMemo(() => ({
    src,
    onLoad() {
      setState('success');
      onStateChange && onStateChange('success');
    },
    onError() {
      setState('failure');
      onStateChange && onStateChange('failure');
    }
  }), [src, onStateChange]);
  return [state, imgProps];
}

export { useImageLoadingState };
